import * as React from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import autobind from 'autobind-decorator';
import patchData from 'Utils/PatchData';
import displayGlobalMessage from 'Utils/DisplayGlobalMessage';


export interface IVideoSlideProps {
    id: string;
    other_file: string;
}

export interface IVideoSlideState {
    showForm: boolean;
}

export default class VideoSlide extends React.Component<IVideoSlideProps, IVideoSlideState> {
    constructor(props: IVideoSlideProps) {
        super(props);

        this.state = {
            showForm: false
        }
    }

    @autobind
    public onSave(event) {
        const url = `/video/api/video/${this.props.id}/?format=json`;

        event.preventDefault();
        const form = event.currentTarget;
        console.log('form=>',form);
        const formData = new FormData();
        formData.append('other_file',form['slide']['files'][0]);
        console.log('formData=>', formData);

        patchData(url, formData, "FormData")
            .then(response => {
                console.log('slide upload response=>', response);
                displayGlobalMessage("Slide Updated","success");
                this.setState({showForm:false})
            })
            .catch(error => {
                console.log('slide upload error=>', error);
                displayGlobalMessage("Slide Upload Failed","error");
            }
            );

    }

    @autobind
    public onRemove() {
        console.log('remove not implemented');
    }


    public render() {
        return (
            this.state.showForm ?
                (
                    <Form onSubmit={this.onSave}>
                        <Form.Group as={Row} controlId="slide">
                            <Form.Label>
                                Slide
                        </Form.Label>

                            <Form.Control type="file" />

                        </Form.Group>

                        <Form.Group as={Row}>
                            <Col sm={{ span: 4, offset: 2 }}>
                                <Button variant="success" type="submit">Save</Button>
                            </Col>
                            <Col sm={{ span: 4, offset: 2 }}>
                                <Button variant="danger" type="button" onClick={(event) => { event.preventDefault(); this.setState({ showForm: false }) }}>Cancel</Button>
                            </Col>
                        </Form.Group>
                    </Form>
                )
                :

                <div className="video-slide">
                    {
                        this.props.other_file !== '/media/' ?

                            <a href={this.props.other_file} target="_blank">View</a> :
                            <div>No Slides Uploaded</div>

                    }

                    <Row>
                        <Col>
                            <Button variant="primary" onClick={() => { this.setState({ showForm: true }) }}>
                                Change
                            </Button>
                        </Col>
                        <Col>
                            <Button variant="danger" onClick={this.onRemove}>
                                Remove
                            </Button>
                        </Col>
                    </Row>

                </div>


        );
    }
}
